import React from 'react';
import { Trash2 } from 'lucide-react';
import { BOQ_UNITS } from '../../constants/boq';

/**
 * A single BOQ material row (v3_58 — materials-only BOQ, no SKU catalog, no price, no credits,
 * no category chain, no execution packages). The interior designer just types the material name +
 * quantity + unit of measure.
 *
 * Row shape: { id, interiorDesignerBoqId?, materialName, quantity, unit, notes }
 *
 * Props:
 *  - updateRow(sectionIndex, index, updates) / deleteRow(sectionIndex, index) — bound to the area.
 */
const cellInput =
    'w-full px-2 py-1.5 text-sm bg-white border border-slate-200 rounded-md outline-none focus:border-flamingo-400 focus:ring-1 focus:ring-flamingo-300/40';

const BoqRowGrouped = ({ row, index, sectionIndex, updateRow, deleteRow }) => {
    return (
        <tr className="border-b border-slate-100 last:border-b-0 hover:bg-slate-50/50 align-top">
            {/* Material name (free text) */}
            <td className="py-2 px-3">
                <input
                    type="text"
                    className={cellInput}
                    value={row.materialName || ''}
                    onChange={(e) => updateRow(sectionIndex, index, { materialName: e.target.value })}
                    placeholder="e.g. 18mm BWP plywood"
                />
            </td>

            {/* Quantity */}
            <td className="py-2 px-3">
                <input
                    type="number"
                    min="0"
                    step="any"
                    className={`${cellInput} text-right`}
                    value={row.quantity ?? ''}
                    onChange={(e) => updateRow(sectionIndex, index, { quantity: e.target.value })}
                    placeholder="0"
                />
            </td>

            {/* Unit of measure */}
            <td className="py-2 px-3">
                <select
                    className={cellInput}
                    value={row.unit || ''}
                    onChange={(e) => updateRow(sectionIndex, index, { unit: e.target.value })}
                >
                    <option value="">— Unit —</option>
                    {BOQ_UNITS.map((u) => (
                        <option key={u.value} value={u.value}>{u.label}</option>
                    ))}
                </select>
            </td>

            {/* Notes */}
            <td className="py-2 px-3">
                <input
                    type="text"
                    className={cellInput}
                    value={row.notes || ''}
                    onChange={(e) => updateRow(sectionIndex, index, { notes: e.target.value })}
                    placeholder="(optional)"
                />
            </td>

            {/* Delete */}
            <td className="py-2 px-1.5 text-center">
                <button
                    type="button"
                    onClick={() => deleteRow(sectionIndex, index)}
                    className="w-7 h-7 rounded-md text-slate-400 hover:text-rose-600 hover:bg-rose-50 inline-flex items-center justify-center"
                    title="Remove row"
                >
                    <Trash2 size={14} />
                </button>
            </td>
        </tr>
    );
};

export default BoqRowGrouped;
